import QuizPage from "../../features/dashboard/quiz/QuizPage";

function QuizesDB() {
  return <QuizPage />;
}

export default QuizesDB;
